import { Pagination, createTable, Link as LinkMagik } from "@inmagik/magik-ui"
import { useMemo } from "react"
import type { Faq, FiltersBase } from "../../types"
import { PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<Faq>()

export function TableFaqs({
  faqs,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  faqs: Faq[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {

  const numPages = useMemo(() => {
    if (!faqs) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [faqs, count])
  return (
    <Table
      data={faqs}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Column
        title="Domanda"
        name="question"
        sortable
        width="minmax(max-content, 1fr)"
        render={(f) => (
          <Link to={`/faqs/faqs/${f.id}`}>
            <LinkMagik className="text-dark">{f.question}</LinkMagik>
          </Link>
        )}
        stickyLeft
        // TODO badge
      />

      <Table.Column
        title="Ordine"
        name="order"
        sortable
        width="150px"
        render={(f) => (
          <div>
            {f.order}
          </div>
        )}
      />
      

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} FAQs
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
